import React, { useEffect, useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { Textbox } from "./Textbox";
import { Button, Form, FormLabel, InputGroup, Table } from "react-bootstrap";
import {
  faEnvelope,
  faMinusSquare,
  faMobile,
  faPencil,
  faPlug,
  faPlus,
  faPlusSquare,
  faSave,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SelectBox } from "./SelectBox";
import { API_URL_ENDPOINT } from "../appsetting";
import { useApi } from "../helpers/useApi";
import { gstRateMap, sendError, sendSuccess } from "../helpers/Helper";
import { faInternetExplorer } from "@fortawesome/free-brands-svg-icons";
import Skeleton from "react-loading-skeleton";
import { useAuth } from "../store/AuthContext";
import SelectSearch from "./SelectSearch";
const Bilty = ({ onBiltyCreated, biltyID = 0 }) => {
  const callApi = useApi();
  const methods = useForm();
  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
    watch,
    setValue,
  } = methods;
  const isInsured = watch("isInsured");
  const [currentCompany, setCurrentCompany] = useState({});
  const [dataLoading, setDataLoading] = useState(false);
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);

  const [fromCity, setFromCity] = useState([]);
  const [toCity, setToCity] = useState([]);

  const [showAddProductForm, setShowAddProductForm] = useState(false);
  const [products, setProducts] = useState([]);
  const [currentProduct, setCurrentProduct] = useState({
    materialName: "",
    hsnCode: "",
    packagingType: "",
    actualWeight: "",
    chargeWeight: "",
    unit: "",
    noofArtical: "",
    chargeRate: "1",
    isFixedCharge: false,
    rate: "",
    totalAmount: "",
  });

  const [productErrors, setProductErrors] = useState({});

  const handleProductChange = (name, value) => {
    const updatedProduct = { ...currentProduct, [name]: value };

    updatedProduct.totalAmount = calculateTotalAmount(updatedProduct)?.toFixed(2);

    setCurrentProduct(updatedProduct);
    setProductErrors((prev) => ({ ...prev, [name]: null }));
  };

  const calculateTotalAmount = ({
    chargeRate,
    rate,
    actualWeight,
    chargeWeight,
  }) => {
    if (!chargeRate || !rate || (!actualWeight && !chargeWeight)) return 0;

    const parsedRate = parseFloat(rate || 0);
    const parsedActualWeight = parseFloat(actualWeight || 0);
    const parsedChargeWeight = parseFloat(chargeWeight || 0);

    if (chargeRate === "1") {
      return parsedActualWeight * parsedRate;
    } else if (chargeRate === "2") {
      return parsedChargeWeight * parsedRate;
    } else if (chargeRate === "3") {
      return rate;
    }

    return 0;
  };

  const calculateMainTotalAmount = () => {
    const basicFreight = parseFloat(watch("basicFreight") || 0);
    const loadingUnloadingCharge = parseFloat(
      watch("loadingUnloadingCharge") || 0
    );
    const kantaCharge = parseFloat(watch("kantaCharge") || 0);
    const otherCharge = parseFloat(watch("otherCharge") || 0);
    const gstRateKey = watch("gstRate") || "0";
    const gstPercent = gstRateMap[gstRateKey];
    const subTotal =
      basicFreight + loadingUnloadingCharge + kantaCharge + otherCharge;
    const gstAmount = subTotal * (gstPercent / 100);
    const total = subTotal + gstAmount;
    setSubTotal(subTotal);
    setTotal(total);
  };

  useEffect(() => {
    LoadCityPoints();
    if(biltyID!=0){ //edit
      getBiltyDetails();
    }else{
      getCurrentCompany();
      reset({
        isInsured: "false",
        tranportMode : "ByRoad"
        // detentionCharge: "0",
        // basicFreight : 0,
        // kantaCharge: "0",
        // otherCharge: "0",
        // loadingUnloadingCharge: "0",
      });
    }
  }, []);

  const addProduct = () => {
    const requiredFields = [
      "materialName",
      // "hsnCode",
      "actualWeight",
      "chargeWeight",
      "unit",
      "chargeRate",
      "rate",
    ];

    const newErrors = {};
    requiredFields.forEach((field) => {
      if (!currentProduct[field]) {
        newErrors[field] = `${field} is required`;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setProductErrors(newErrors);
      return;
    }

    const productWithId = {
      ...currentProduct,
      id: Date.now() + Math.random().toString(16).slice(2),
    };

    // setProducts((prev) => [...prev, productWithId]);
    setProducts((prev) => {
      const updatedProducts = [...prev, productWithId];
      // run doSum after setting
      setTimeout(() => doSum(updatedProducts), 0); // optionally pass updatedProducts
      return updatedProducts;
    });
    calculateMainTotalAmount();
    setCurrentProduct({});
    setProductErrors({});
    setShowAddProductForm(false);
  };

  const doSum = (customProducts) => {
    // Calculate total basic freight using the `total` key of each product
    const list = customProducts || products;
    const totalFreight = list.reduce(
      (sum, p) => sum + (parseFloat(p.totalAmount) || 0),
      0
    );
    reset({
      basicFreight: totalFreight.toFixed(2),
    });
    calculateMainTotalAmount();
  };

  const editProduct = (id) => {
    
    const productToEdit = products.find((p) => p.id === id);
    if (productToEdit) {
      setShowAddProductForm(true);
      const updatedProducts = products.filter((p) => p.id !== id);
      console.log("Product ID", id)
      console.log("All Product", products)
      console.log("Updated", productToEdit)
      setCurrentProduct(productToEdit);
      setProducts(updatedProducts);
      doSum(updatedProducts);
    }
  };

  const deleteProduct = (id) => {
    const updatedProducts = products.filter((p) => p.id !== id);
    setProducts(updatedProducts);
    doSum(updatedProducts);
    calculateMainTotalAmount();
  };

  const onBiltySubmit = async (data) => {
    const payload = {
      biltyID : biltyID,
      consignorName: data.consignorCompanyName || null,
      consignorGST: data.consignorGST || null,
      consignorAddress: data.consignorAddress || null,
      consigneeName: data.consigneeCompanyName || null,
      consigneeGST: data.consigneeGST || null,
      consigneeAddress: data.consigneeAddress || null,
      invoiceNumber: data.invoiceNumber,
      invoiceDate: data.invoiceDate === "" ? null : data.invoiceDate,
      amountAndEWayBillNumber: data.eWayBillNumber,
      vehicleNumber: data.truckNumber,
      ownerName: data.truckOwnerName,
      loadType: data.loadType,
      driverName: data.driverName,
      contactNumber: data.driverContactNumber,
      dlNumber: data.driverLicenseNumber,
      type: data.freightDetail,
      basicFreight: parseFloat(data.basicFreight) || 0,
      loadingUnloadingCharge: parseFloat(data.loadingUnloadingCharge) || 0,
      kantaCharge: parseFloat(data.kantaCharge) || 0,
      otherCharge: parseFloat(data.otherCharge) || 0,
      gstRate: data.gstRate,
      gstPayBy: data.gstPayBy,
      advanceAmountPaid:
      data.advancePaidAmount === "" ? 0 : data.advanceAmountPaid,
      isInsured: data.isInsured === ("true" || true),
      insuranceCompanyName: data.insuranceCompanyName,
      policyNumber: data.policyNumber,
      insuranceAmount: data.insuranceAmount,
      insuranceDate: data.insuranceDate,
      riskType: data.riskType,
      transportMode: data.tranportMode,
      detentionChargeType: data.chargeType === "" ? null : data.chargeType,
      detentionCharges: parseFloat(data.detentionCharge) || 0,
      otherRemarks: data.otherRemark,
      from: parseInt(data.from) || 0,
      to: parseInt(data.to) || 0,
      items: products?.map((product) => ({
        materialName: product.materialName || "",
        hsnCode: product.hsnCode || "",
        packagingType: parseInt(product.packagingType) || null,
        actualWeight: parseFloat(product.actualWeight) || 0,
        chargeWeight: parseFloat(product.chargeWeight) || 0,
        unit: product.unit || 0,
        articalQuantity: parseInt(product.noofArtical) || 0,
        chargeType: parseInt(product.chargeRate) || 0,
        isFixed: product.isFixedCharge || false,
        rate: parseFloat(product.rate) || 0,
        totalAmount: parseFloat(product.totalAmount) || 0,
      })),
    };
    console.log("Data", payload);
    try {
      const response = await callApi(API_URL_ENDPOINT.Bilty, {
        method: biltyID !=0 ? "PUT" : "POST",
        data: payload,
      });
      if (response.status) {
        sendSuccess(response.message);
        reset();
        onBiltyCreated();
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  };

  const getCurrentCompany = async () => {
    try {
      setDataLoading(true);
      const response = await callApi(
        API_URL_ENDPOINT.Company + `/current-company`
      );
      if (response.status) {
        if (response?.data == null) {
          return;
        }
        setCurrentCompany(response?.data ?? {});
      } else {
        throw new Error(response.message);
      }
    } catch {
      setCurrentCompany({});
    } finally {
      setDataLoading(false);
    }
  };

  const getBiltyDetails = async () => {
    try {
      setDataLoading(true);
      const response = await callApi(
        API_URL_ENDPOINT.Bilty + `/${biltyID}`
      );
      if (response.status) {
        if (response?.data == null) {
          return;
        }
        var data = response.data;
        reset({
          consignorCompanyName: data.consignorName || null,
          consignorGST: data.consignorGST || null,
          consignorAddress: data.consignorAddress || null,
          consigneeCompanyName: data.consigneeName || null,
          consigneeGST: data.consigneeGST || null,
          consigneeAddress: data.consigneeAddress || null,
          invoiceNumber: data.invoiceNumber,
          invoiceDate: data.invoiceDate === "" ? null : data.invoiceDate,
          eWayBillNumber: data.amountAndEWayBillNumber,
          truckNumber: data.vehicleNumber,
          truckOwnerName: data.ownerName,
          loadType: data.loadType,
          driverName: data.driverName,
          driverContactNumber: data.contactNumber,
          driverLicenseNumber: data.dlNumber,
          freightDetail: data.type?.toString(),
          basicFreight: data.basicFreight || 0,
          loadingUnloadingCharge: data.loadingUnloadingCharge || 0,
          kantaCharge: data.kantaCharge || 0,
          otherCharge: data.otherCharge || 0,
          gstRate: data.gstRate?.toString(),
          gstPayBy: data.gstPayBy,
          advanceAmountPaid: data.advanceAmountPaid,
          isInsured: data.isInsured?.toString(),
          insuranceCompanyName: data.insuranceCompanyName,
          policyNumber: data.policyNumber,
          insuranceAmount: data.insuranceAmount,
          insuranceDate: data.insuranceDate,
          riskType: data.riskType,
          tranportMode: data.transportMode,
          chargeType: data.detentionChargeType?.toString(),
          detentionCharge: data.detentionCharges || 0,
          otherRemark: data.otherRemarks,
          from: parseInt(data.from) || 0,
          to: parseInt(data.to) || 0,
        });

      const mappedProducts = data?.items?.map((item) => ({
        id: item?.id,
        materialName: item.materialName,
        hsnCode: item.hsnCode,
        packagingType: item.packagingType,
        actualWeight: item.actualWeight,
        chargeWeight: item.chargeWeight || "0",
        unit: item.unit,
        noofArtical: item.articalQuantity, // mapping key
        chargeRate: "1", // default as per your model
        isFixedCharge: false, // default as per your model
        rate: item.rate,
        totalAmount: item.totalAmount,
      }));

      setProducts(mappedProducts);
      calculateMainTotalAmount();
      // setCurrentCompany(response?.data ?? {});
      } else {
        throw new Error(response.message);
      }
    } catch {
      // setCurrentCompany({});
    } finally {
      setDataLoading(false);
    }
  };

  const LoadPoints = async (gst, point) => {
    if (point === "TO") {
      setToCity([]);
    } else if (point === "FROM") {
      setFromCity([]);
    }
    if (gst?.length !== 15) return;

    const stateCode = gst.substring(0, 2);

    try {
      const filters = [];
      if (stateCode) filters.push(`StateGSTCode:${stateCode}`);

      const queryParams = [
        filters.length ? `filters=${filters.join(",")}` : null,
        `pageNo=1`,
        `pageSize=2000`,
        `sortOrder=desc`,
      ]
        .filter(Boolean)
        .join("&");

      const response = await callApi(
        `${API_URL_ENDPOINT.Pincodes}?${queryParams}`
      );

      if (response.status) {
        const cityList = response.data?.items || [];

        if (point === "TO") {
          setToCity(cityList);
        } else if (point === "FROM") {
          setFromCity(cityList);
        }
      }
    } catch {
      if (point === "TO") {
        setToCity([]);
      } else if (point === "FROM") {
        setFromCity([]);
      }
    }
  };

  const LoadCityPoints = async () => {
  try {
    const filters = [];
    // if (stateCode) filters.push(`StateGSTCode:${stateCode}`);

    const queryParams = [
      filters.length ? `filters=` : null,
      `pageNo=1`,
      `pageSize=2000`,
      `sortOrder=desc`,
    ]
      .filter(Boolean)
      .join("&");

    const response = await callApi(
      `${API_URL_ENDPOINT.Pincodes}?${queryParams}`
    );

    if (response.status) {
      const cityList = response.data?.items || [];
        setToCity(cityList);
        setFromCity(cityList);
    }else{
      throw new Error()
    }
  } catch {
      setToCity([]);
      setFromCity([]);
    }
  }

  return (
    <div>
      {/* <div style={{ background: "#f5f8fb" }} className="mb-2 row">
        <strong style={{ fontSize: 20 }} className="w-100 d-block px-2 text-center">
          Company Detail
        </strong>
      </div> */}
      {biltyID === 0 && (
        <div className="d-flex">
        <div className="mb-2 w-100">
          <div className="w-100 pb-2">
            <h5 className="text-center">
              {dataLoading ? (
                <Skeleton height={30} width={200} />
              ) : (
                currentCompany?.company?.companyName
              )}{" "}
            </h5>
            <div className="d-flex align-items-center pb-1 justify-content-center">
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <strong style={{ fontSize: 16 }}>Branch Code- </strong>
                    <span>{currentCompany?.branchCode || "N/A"}</span>
                  </>
                )}
              </div>
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <strong style={{ fontSize: 16 }}>Reg. Number-</strong>
                    <span>
                      {currentCompany?.company?.transportRegNumber || "N/A"}
                    </span>
                  </>
                )}
              </div>
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <strong style={{ fontSize: 16 }}>Jurisdiction-</strong>
                    <span>{currentCompany?.company?.jurisdiction}</span>
                  </>
                )}
              </div>
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <strong style={{ fontSize: 16 }}>GST-</strong>
                    <span>{currentCompany?.company?.gstNumber}</span>
                  </>
                )}
              </div>
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <strong style={{ fontSize: 16 }}>PAN-</strong>
                    <span>{currentCompany?.company?.panNumber}</span>
                  </>
                )}
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <FontAwesomeIcon icon={faMobile} className="me-2" />
                    <span>{currentCompany?.company?.mobile || "N/A"}</span>
                  </>
                )}
              </div>
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                    <span>{currentCompany?.company?.email || "N/A"}</span>
                  </>
                )}
              </div>
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <FontAwesomeIcon
                      icon={faInternetExplorer}
                      className="me-2"
                      />
                    <span>{currentCompany?.company?.website || "N/A"}</span>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      )}

      {(Object.keys(currentCompany).length != 0 || biltyID != 0) && !dataLoading && (
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onBiltySubmit)}>
            <div className="row">
              <div className="col-md-6">
                <div style={{ background: "#f5f8fb" }} className="row">
                <strong
                style={{ fontSize: 20 }}
                    className="w-100 d-block px-2"
                  >
                    Consignor Detail
                  </strong>
                </div>
                <div className="my-2">
                  <Textbox
                    Label="Company Name"
                    name={"consignorCompanyName"}
                    Placeholder="Company Name"
                    // validationRules={{ required: "Company Name is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </div>
                <div className="my-2">
                  <Textbox
                    Label="GST Number"
                    name={"consignorGST"}
                    // onBlur={(e) => LoadPoints(e.target.value.trim(), "FROM")}
                    Placeholder="GST Number"
                    // validationRules={{
                    //   required: "GST Number is required",
                    //   pattern: {
                    //     value:
                    //       /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                    //     message: "Invalid GST Number",
                    //   },
                    // }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </div>
                <div className="my-2">
                  <Textbox
                    Label="Address"
                    name={"consignorAddress"}
                    Placeholder="Address"
                    // validationRules={{ required: "Address is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </div>
                <div className="my-2">
                  <Controller
                    name="from"
                    control={control}
                    rules={{ required: "Required" }}
                    render={({ field }) => (
                      <SelectSearch
                        Label="Select From"
                        errors={errors}
                        options={fromCity?.map((place) => ({
                          label: place.placeName || place.cityName,
                          value: place.id,
                        }))}
                        value={field.value}
                        onChange={field.onChange}
                      />
                    )}
                  />

                  {/* <SelectBox
                  Label="From"
                  name={"from"}
                  validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                >
                  <option value={""} selected>Select From Point</option>
                  {fromCity?.length>0 && (
                    fromCity.map((item, index)=>(
                      <option value={item?.id}>{item?.placeName}</option>
                    ))
                  )}
                </SelectBox> */}
                </div>
              </div>

              <div className="col-md-6">
                <div style={{ background: "#f5f8fb" }} className="row">
                  <strong
                    style={{ fontSize: 20 }}
                    className="w-100 d-block px-2"
                  >
                    Consignee Detail
                  </strong>
                </div>
                <div className="my-2">
                  <Textbox
                    Label="Company Name"
                    name={"consigneeCompanyName"}
                    Placeholder="Company Name"
                    // validationRules={{ required: "Company Name is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </div>
                <div className="my-2">
                  <Textbox
                    Label="GST Number"
                    name="consigneeGST"
                    // onBlur={(e) => LoadPoints(e.target.value.trim(), "TO")}
                    Placeholder="GST Number"
                    // validationRules={{
                    //   required: "GST Number is required",
                    //   pattern: {
                    //     value:
                    //       /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                    //     message: "Invalid GST Number",
                    //   },
                    // }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </div>
                <div className="my-2">
                  <Textbox
                    Label="Address"
                    name={"consigneeAddress"}
                    Placeholder="Delivery Address"
                    // validationRules={{ required: "Address is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </div>
                <div className="my-2">
                  <Controller
                    name="to"
                    control={control}
                    rules={{ required: "Required" }}
                    render={({ field }) => (
                      <SelectSearch
                        Label="Select To"
                        errors={errors}
                        options={toCity?.map((place) => ({
                          label: place.placeName,
                          value: place.id,
                        }))}
                        value={field.value}
                        onChange={field.onChange}
                      />
                    )}
                  />

                  {/* <SelectBox
                  Label="To"
                  name={"to"}
                  validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                >
                  <option value={""} selected>Select To Point</option>
                  {toCity?.length>0 && (
                    toCity.map((item, index)=>(
                      <option value={item?.id}>{item?.placeName}</option>
                    ))
                  )}
                </SelectBox> */}
                </div>
              </div>
            </div>

            <div className="row">
              <div style={{ background: "#f5f8fb" }} className="mt-4 d-flex align-items-center">
                <strong style={{ fontSize: 20 }} className="w-100 d-block">
                  Material Detail
                </strong>
                {showAddProductForm ? (
                  <FontAwesomeIcon onClick={()=>setShowAddProductForm(false)} style={{fontSize:20, cursor:'pointer'}} className="text-danger" icon={faMinusSquare}/>
                ):(
                  <FontAwesomeIcon onClick={()=>setShowAddProductForm(true)} style={{fontSize:20, cursor:'pointer'}} className="text-success" icon={faPlusSquare}/>
                )}
              </div>

              {showAddProductForm && (
                <>
                <div className="my-2 col-md-3">
                <Form.Label className="mb-0">
                  Material Name <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  disabled={false}
                  className="shadow-none"
                  placeholder="Material Name"
                  type="text"
                  onChange={(e) =>
                    handleProductChange("materialName", e.target.value)
                  }
                  value={currentProduct?.materialName || ""}
                />
                {productErrors?.materialName && (
                  <>
                    <span className="text-danger" style={{ fontSize: 14 }}>
                      Material Name is Required
                    </span>
                  </>
                )}
              </div>
              <div className="my-2 col-md-2">
                <Form.Label className="mb-0">HSN Code</Form.Label>
                <Form.Control
                  disabled={false}
                  className="shadow-none"
                  placeholder="HSN Code"
                  type="text"
                  onChange={(e) =>
                    handleProductChange("hsnCode", e.target.value)
                  }
                  value={currentProduct?.hsnCode || ""}
                />
                {productErrors?.hsnCode && (
                  <>
                    <span className="text-danger" style={{ fontSize: 14 }}>
                      HSN Code is Required
                    </span>
                  </>
                )}
              </div>
              <div className="my-2 col-md-3">
                <Form.Label className="mb-0">Packaging Type</Form.Label>
                <Form.Select
                  disabled={false}
                  className="shadow-none"
                  onChange={(e) =>
                    handleProductChange(
                      "packagingType",
                      e.target.value
                    )
                  }
                  value={currentProduct?.packagingType || ""}
                >
                  <option value="">Select Packaging Type</option>
                  <option value="CartonBox">Carton Box</option>
                  <option value="Crate">Crate</option>
                  <option value="Pallet">Pallet</option>
                  <option value="Drum">Drum</option>
                  <option value="Bag">Bag</option>
                  <option value="Sack">Sack</option>
                  <option value="Bale">Bale</option>
                  <option value="Bundle">Bundle</option>
                  <option value="WoodenBox">Wooden Box</option>
                  <option value="Container">Container</option>
                  <option value="Envelope">Envelope</option>
                  <option value="Reel">Reel</option>
                  <option value="IBCTank">IBC Tank</option>
                  <option value="Tote">Tote</option>
                  <option value="Can">Can</option>
                  <option value="Cylinder">Cylinder</option>
                  <option value="Roll">Roll</option>
                </Form.Select>

                {/* {productErrors?.packagingType && (
                <>
                  <span className="text-danger" style={{ fontSize: 14 }}>
                    Type is Required
                  </span>
                </>
              )} */}
              </div>
              <div className="my-2 col-md-2">
                <Form.Label className="mb-0">
                  Actual Weight <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  disabled={false}
                  className="shadow-none"
                  placeholder="Actual Weight"
                  type="number"
                  onChange={(e) =>
                    handleProductChange("actualWeight", e.target.value)
                  }
                  value={currentProduct?.actualWeight || ""}
                />
                {productErrors?.actualWeight && (
                  <>
                    <span className="text-danger" style={{ fontSize: 14 }}>
                      Weight is Required
                    </span>
                  </>
                )}
              </div>
              <div className="my-2 col-md-2">
                <Form.Label className="mb-0">
                  Charge Weight <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  disabled={false}
                  className="shadow-none"
                  placeholder="Charge Weight"
                  type="number"
                  onChange={(e) =>
                    handleProductChange("chargeWeight", e.target.value)
                  }
                  value={currentProduct?.chargeWeight || ""}
                />
                {productErrors?.chargeWeight && (
                  <>
                    <span className="text-danger" style={{ fontSize: 14 }}>
                      Weight is Required
                    </span>
                  </>
                )}
              </div>
              <div className="my-2 col-md-2">
                <Form.Label className="mb-0">
                  Unit <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Select
                  disabled={false}
                  className="shadow-none"
                  onChange={(e) =>
                    handleProductChange("unit", e.target.value)
                  }
                  value={currentProduct?.unit || ""}
                >
                  <option value="">Select UNIT</option>
                  <option value="KG">KG</option>
                  <option value="Ton">Ton</option>
                  <option value="PCS">PCS</option>
                  <option value="Box">Box</option>
                  <option value="Packet">Packet</option>
                  <option value="Bundle">Bundle</option>
                  <option value="Bag">Bag</option>
                  <option value="Drum">Drum</option>
                  <option value="Crate">Crate</option>
                  <option value="Container">Container</option>
                  <option value="Liter">Liter</option>
                  <option value="CBM">CBM</option>
                </Form.Select>

                {productErrors?.unit && (
                  <>
                    <span className="text-danger" style={{ fontSize: 14 }}>
                      UNIT is Required
                    </span>
                  </>
                )}
              </div>
              <div className="my-2 col-md-1">
                <Form.Label className="mb-0" style={{ fontSize: 12 }}>
                  No. of Artical
                </Form.Label>
                <Form.Control
                  disabled={false}
                  className="shadow-none text-center"
                  placeholder="0"
                  type="number"
                  onChange={(e) =>
                    handleProductChange("noofArtical", e.target.value)
                  }
                  value={currentProduct?.noofArtical || ""}
                />
              </div>
              <div className="my-2 col-md-4">
                <div>
                  <FormLabel className="mb-0">
                    Charge Rate <span style={{ color: "red" }}>*</span>
                  </FormLabel>
                  <div className=" py-2">
                    <div className="d-flex align-items-center justify-content-start">
                      <div className="me-3">
                        <input
                          name="chargeRate"
                          onChange={(e) =>
                            handleProductChange("chargeRate", e.target.value)
                          }
                          type="radio"
                          value={"1"}
                          checked={currentProduct?.chargeRate === "1"}
                          style={{ width: 20, height: 20 }}
                          className="form-check-input shadow-none me-2 mt-0"
                        />
                        <span>Actual Wt.</span>
                      </div>
                      <div className="me-3">
                        <input
                          name="chargeRate"
                          type="radio"
                          onChange={(e) =>
                            handleProductChange("chargeRate", e.target.value)
                          }
                          value={"2"}
                          checked={currentProduct.chargeRate === "2"}
                          style={{ width: 20, height: 20 }}
                          className="form-check-input shadow-none me-2 mt-0"
                        />
                        <span>Charge Wt.</span>
                      </div>
                      <div>
                        <input
                          name="chargeRate"
                          type="radio"
                          onChange={(e) =>
                            handleProductChange("chargeRate", e.target.value)
                          }
                          value={"3"}
                          checked={currentProduct.chargeRate === "3"}
                          style={{ width: 20, height: 20 }}
                          className="form-check-input shadow-none me-2 mt-0"
                        />
                        <span>Fixed</span>
                      </div>
                    </div>
                    {productErrors?.chargeRate && (
                      <>
                        <span className="text-danger" style={{ fontSize: 14 }}>
                          Charge Rate is Required
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="my-2 col-md-2">
                <Form.Label className="mb-0">
                  Rate <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <InputGroup className="rounded-none">
                  <InputGroup.Text>₹</InputGroup.Text>
                  <Form.Control
                    disabled={false}
                    className="rounded-1"
                    placeholder="Rate"
                    type="number"
                    onChange={(e) =>
                      handleProductChange("rate", e.target.value)
                    }
                    value={currentProduct?.rate || ""}
                  />
                </InputGroup>
                {productErrors?.rate && (
                  <>
                    <span className="text-danger" style={{ fontSize: 12 }}>
                      Rate is Required
                    </span>
                  </>
                )}
              </div>
              <div className="my-2 col-md-2">
                <Form.Label className="mb-0">Total Amount</Form.Label>
                <InputGroup className="rounded-none" disabled={true}>
                  <InputGroup.Text>₹</InputGroup.Text>
                  <Form.Control
                    disabled={true}
                    className="shadow-none"
                    placeholder="Total Amount"
                    type="number"
                    onChange={(e) =>
                      handleProductChange("totalAmount", e.target.value)
                    }
                    value={currentProduct?.totalAmount || ""}
                  />
                </InputGroup>
              </div>
              <div className="my-2 col-md-1">
                <Form.Label className="mb-0"></Form.Label>
                <Button variant="success" className="mt-4" onClick={addProduct}>
                  Add
                </Button>
              </div>
                </>
              )}
            </div>

            {products.length > 0 && (
              <div className="mt-4">
                <Table bordered className="text-center">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Material Name</th>
                      <th>HSN Code</th>
                      <th>Packaging Type</th>
                      <th>Weight</th>
                      <th>Unit</th>
                      <th>No. of Artical</th>
                      <th>Rate</th>
                      <th>Total Amount</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.map((product, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{product.materialName}</td>
                        <td>{product.hsnCode}</td>
                        <td>{product.packagingType}</td>
                        <td>{product.actualWeight}</td>
                        <td>{product.unit}</td>
                        <td>{product.noofArtical}</td>
                        <td>{product.rate}</td>
                        <td>{product.totalAmount}</td>
                        <td>
                          <Button
                            variant="primary"
                            onClick={() => editProduct(product?.id)}
                            className="btn-sm me-2"
                          >
                            <FontAwesomeIcon icon={faPencil} />
                          </Button>
                          <Button
                            variant="danger"
                            onClick={() => deleteProduct(product?.id)}
                            className="btn-sm"
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}

            <div className="row">
              <div style={{ background: "#f5f8fb" }} className="mt-4">
                <strong style={{ fontSize: 20 }} className="w-100 d-block">
                  Invoice & E-Way Bill
                </strong>
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="Invoice Number"
                  name={"invoiceNumber"}
                  Placeholder="Invoice Number"
                  // validationRules={{ required: "Invoice Number is required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Type={"date"}
                  Label="Invoice Date"
                  name={"invoiceDate"}
                  Placeholder="Invoice Date"
                  // validationRules={{ required: "Date is required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="E-way Bill Number"
                  name={"eWayBillNumber"}
                  Placeholder="E-way Bill Number"
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="Truck Number"
                  name={"truckNumber"}
                  Placeholder="Truck Number"
                  // validationRules={{ required: "Truck Number is required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="Owner Name"
                  name={"truckOwnerName"}
                  Placeholder="Owner Name"
                  // validationRules={{ required: "Owner Name is required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-4 my-2">
                <SelectBox
                  Label="Load Type"
                  name={"loadType"}
                  validationRules={{ required: "Load Type is required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                >
                  <option value="">Select Load Type</option>
                  <option value="FullLoad">Full Load</option>
                  <option value="PartLoad">Part Load</option>
                  <option value="PartialLoad">Partial Load</option>
                </SelectBox>
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="Driver Name"
                  name={"driverName"}
                  Placeholder="Driver Name"
                  // validationRules={{ required: "Driver Name is required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="Contact Number"
                  name={"driverContactNumber"}
                  Placeholder="Contact Number"
                  // validationRules={{ required: "Contact Number is required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="License Number"
                  name={"driverLicenseNumber"}
                  Placeholder="License Number"
                  // validationRules={{ required: "DL Number is required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
            </div>

            <div className="row">
              <div style={{ background: "#f5f8fb" }} className="mt-4">
                <strong style={{ fontSize: 20 }} className="w-100 d-block">
                  Freight Detail
                </strong>
              </div>
              <div className="col-md-2 my-2">
                <input
                  {...register("freightDetail", {
                    required: "User is required",
                  })}
                  type="radio"
                  value={"ToPay"}
                  style={{ width: 20, height: 20 }}
                  className="form-check-input shadow-none me-2 mt-0"
                />
                <span>To Pay</span>
              </div>
              <div className="col-md-2 my-2">
                <input
                  {...register("freightDetail", {
                    required: "User is required",
                  })}
                  type="radio"
                  value={"Paid"}
                  style={{ width: 20, height: 20 }}
                  className="form-check-input shadow-none me-2 mt-0"
                />
                <span>Paid</span>
              </div>
              <div className="col-md-8 my-2">
                <input
                  {...register("freightDetail", {
                    required: "User is required",
                  })}
                  type="radio"
                  value={"ToBeBilled"}
                  style={{ width: 20, height: 20 }}
                  className="form-check-input shadow-none me-2 mt-0"
                />
                <span>To be Billed</span>
              </div>
              <div className="col-md-3 my-2">
                <Textbox
                  disabled={true}
                  Type="number"
                  Label="Basic Freight"
                  name={"basicFreight"}
                  Placeholder="Basic Freight"
                  validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-3 my-2">
                <Textbox
                  Label="Loading & Unloading Charges"
                  name={"loadingUnloadingCharge"}
                  onKeyUp={() => calculateMainTotalAmount()}
                  Placeholder="Loading & Unloading Charges"
                  // validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-3 my-2">
                <Textbox
                  Label="Kanta Charge"
                  onKeyUp={() => calculateMainTotalAmount()}
                  name={"kantaCharge"}
                  Placeholder="Kanta Charge"
                  // validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-3 my-2">
                <Textbox
                  Label="Other Charge"
                  onKeyUp={() => calculateMainTotalAmount()}
                  name={"otherCharge"}
                  Placeholder="Other Charge"
                  // validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-3 my-2">
                <SelectBox
                  onChange={() => calculateMainTotalAmount()}
                  Label="GST Rate"
                  name={"gstRate"}
                  validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                >
                  <option value={"Zero"}>Exampted</option>
                  <option value={"Five"}>5%</option>
                  <option value={"Twelve"}>12%</option>
                  <option value={"Eighteen"} selected>18%</option>
                  <option value={"TwentyEight"}>28%</option>
                </SelectBox>
              </div>
              <div className="col-md-3 my-2">
                <SelectBox
                  Label="GST Payable By"
                  name={"gstPayBy"}
                  validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                >
                  <option value={""}>Select Option</option>
                  <option value="Consigner">Consignor</option>
                  <option value="Consignee">Consignee</option>
                  <option value="Transporter">Transporter</option>
                </SelectBox>
              </div>
              <div className="col-md-3 my-2">
                <Textbox
                  Type="number"
                  Label="Advance Paid Amount"
                  name={"advancePaidAmount"}
                  Placeholder="Advance Paid Amount"
                  // validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-3 my-2">
                <SelectBox
                  Label="Paid Via"
                  name="paidVia"
                  validationRules={{
                    validate: (value) => {
                      const advancePaid = watch("advancePaidAmount");
                      if (advancePaid && !value) return "Required";
                      return true;
                    },
                  }}
                  register={register}
                  errors={errors}
                  watch={watch}
                >
                  <option value="">Select Option</option>
                  <option value="1">Cash</option>
                  <option value="2">Bank</option>
                </SelectBox>
              </div>
              {/* <div className="col-md-4 my-2">
              <Textbox
                Type="number"
                Label="Remaining Amount"
                name={"remainingAmount"}
                Placeholder="Remaining Amount"
                validationRules={{ required: "Required" }}
                register={register}
                errors={errors}
                watch={watch}
              />
            </div> */}
              <div className="col-md-12 my-4">
                <strong>Sub Total : </strong> {subTotal}
              </div>
              <div className="col-md-12">
                <strong>Total Amount With GST : </strong> {total}
              </div>
            </div>

            <div className="row">
              <div style={{ background: "#f5f8fb" }} className="mt-4">
                <strong style={{ fontSize: 20 }} className="w-100 d-block">
                  Insurance Detail
                </strong>
              </div>
              <div className="col-md-2 my-2">
                <input
                  {...register("isInsured", { required: "Required" })}
                  type="radio"
                  value={false}
                  style={{ width: 20, height: 20 }}
                  className="form-check-input shadow-none me-2 mt-0"
                />
                <span>Not Insured</span>
              </div>
              <div className="col-md-10 my-2">
                <input
                  {...register("isInsured", { required: "Required" })}
                  type="radio"
                  value={true}
                  style={{ width: 20, height: 20 }}
                  className="form-check-input shadow-none me-2 mt-0"
                />
                <span>Insured</span>
              </div>
              {isInsured === "true" && (
                <>
                  <div className="col-md-4 my-2">
                    <Textbox
                      Label="Company Name"
                      name={"insuranceCompanyName"}
                      Placeholder="Company Name"
                      validationRules={{ required: "Required" }}
                      register={register}
                      errors={errors}
                      watch={watch}
                    />
                  </div>
                  <div className="col-md-4 my-2">
                    <Textbox
                      Label="Policy Number"
                      name={"policyNumber"}
                      Placeholder="Policy Number"
                      validationRules={{
                        required: "Policy Number is required",
                      }}
                      register={register}
                      errors={errors}
                      watch={watch}
                    />
                  </div>
                  <div className="col-md-4 my-2">
                    <Textbox
                      Label="Insurance Amount"
                      name={"insuranceAmount"}
                      Placeholder="Insurance Amount"
                      validationRules={{ required: "Amount is required" }}
                      register={register}
                      errors={errors}
                      watch={watch}
                    />
                  </div>
                  <div className="col-md-4 my-2">
                    <Textbox
                      Type="date"
                      Label="Insurance Date"
                      name={"insuranceDate"}
                      Placeholder="Insurance Date"
                      validationRules={{ required: "Date is required" }}
                      register={register}
                      errors={errors}
                      watch={watch}
                    />
                  </div>
                </>
              )}
              <div className="col-md-4 my-2">
                <SelectBox
                  Label="Risk Type"
                  name={"riskType"}
                  validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                >
                  <option value="">Select Option</option>
                  <option value={"AtOwnerRisk"}>At Owner's Risk</option>
                  <option value={"AtCarrierRisk"}>At Carrier's Risk</option>
                </SelectBox>
              </div>
              <div className="col-md-4 my-2">
                <SelectBox
                  Label="Mode of Transport"
                  name={"tranportMode"}
                  validationRules={{ required: "Required" }}
                  register={register}
                  errors={errors}
                  watch={watch}
                >
                  <option value="">Select Option</option>
                  <option value={"ByRoad"}>
                    By Road
                  </option>
                  <option value={"ByRail"}>By Rail</option>
                  <option value={"ByOcean"}>By Ocean</option>
                  <option value={"ByAir"}>By Air</option>
                </SelectBox>
              </div>
            </div>

            <div className="row">
              <div style={{ background: "#f5f8fb" }} className="mt-4">
                <strong style={{ fontSize: 20 }} className="w-100 d-block">
                  Detention Details
                </strong>
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="Detention Charges"
                  name={"detentionCharge"}
                  Placeholder="Detention Charge"
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
              <div className="col-md-4 my-2">
                <SelectBox
                  Label="Charge Type"
                  name={"chargeType"}
                  validationRules={{
                    validate: (value) => {
                      const detentionCharge = watch("detentionCharge");
                      if (detentionCharge > 0 && !value) return "Required";
                      return true;
                    },
                  }}
                  register={register}
                  errors={errors}
                  watch={watch}
                >
                  <option value={""}>Select Option</option>
                  <option value={"Fixed"}>Fix</option>
                  <option value={"PerDay"}>Per Day</option>
                </SelectBox>
              </div>
              <div className="col-md-4 my-2">
                <Textbox
                  Label="Other Remark"
                  name={"otherRemark"}
                  Placeholder="Other Remark"
                  register={register}
                  errors={errors}
                  watch={watch}
                />
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-4 mt-2">
                <Button variant="primary" type="submit" className="btn">
                  <FontAwesomeIcon className="me-2" icon={faSave} />
                  {biltyID == 0 ? "Generate Bilty" : "Update Bilty"} 
                </Button>
              </div>
            </div>
          </form>
        </FormProvider>
      )}
    </div>
  );
};

export default Bilty;
